import { render, staticRenderFns } from "./IconBroom.vue?vue&type=template&id=0a3a25db"
import script from "./IconBroom.vue?vue&type=script&lang=js"
export * from "./IconBroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports